import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, mapToCanActivate, mapToResolve } from '@angular/router';
import { OAuth2AuthGuard } from './service/auth/oauth2.guard';
import { WelcomeComponent } from './welcome/welcome.component';
import { ProfileResolver } from './service/auth/profile.resolver';
import { AuthGuard } from './service/auth/auth.guard';
import { dashboardRoutes } from './dashboard/dashboard-routing.module';
import { netzzuordnungenRoutes } from './netzzuordnungen/netzzuordnungen-routing.module';
import { settingsRoutes } from './settings/settings-routing.module';
import { RoleAuthGuard } from './service/auth/role-auth.guard';
import { UserRoles } from './domain/model/roles.enum';
import { netzbetreiberRoutes } from './netzbetreiber/netzbetreiber-routing.module';
import { contactDataRoutes } from './contact-data/contact-data-routing.module';
import { erzeugungsanlageRoutes } from './erzeugungsanlage/erzeugungsanlage-routing.module';
import { planwertRoutes } from './planwert/planwert-routing.module';

const routes: Routes = [
    {
        path: '',
        component: WelcomeComponent,
        canActivate: mapToCanActivate([
            OAuth2AuthGuard,
        ]),
    },
    {
        path: 'dashboard',
        children: dashboardRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: 'erzeugungsanlage',
        children: erzeugungsanlageRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: 'netzbetreiber',
        children: netzbetreiberRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: 'netzzuordnung',
        children: netzzuordnungenRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: 'planwert',
        children: planwertRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
        ]),
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: 'settings',
        children: settingsRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
            RoleAuthGuard,
        ]),
        data: {
            allowedRoles: [
                UserRoles.TDL_ADMIN_USER,
            ],
        },
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: 'contact-data',
        children: contactDataRoutes,
        canActivate: mapToCanActivate([
            AuthGuard,
            RoleAuthGuard,
        ]),
        data: {
            allowedRoles: [
                UserRoles.TDL_VNB_USER,
            ],
        },
        resolve: {
            profile: mapToResolve(ProfileResolver),
        },
    },
    {
        path: '**',
        component: WelcomeComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes,
            {
                enableTracing: false,
                preloadingStrategy: PreloadAllModules,
                useHash: true,
                anchorScrolling: 'enabled',
            },
        ),
    ],
    exports: [
        RouterModule,
    ],
    providers: [
        ProfileResolver,
    ],
})
export class AppRoutingModule {
}
